<div class="d-flex align-items-center">
  <div class="text-reduced-regular color-text-secondary text" [innerHTML]="payload.text"></div>
  <img *ngIf="payload.image" [src]="payload.image" class="ml-4 mr-4 image" />
</div>
